import React from "react";
import { Grid, FormControlLabel, Typography } from "@mui/material";
import {
  CancelledSwitch,
  DelayedSwitch,
  DoneSwitch,
  OnTimeSwitch,
} from "./customSwitches";
import { useDispatch, useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import { getSwitchBg, getSwitchColor } from "helpers/themeColors";
import { green, red, orange, blue } from "@mui/material/colors";
import { filtersOrders } from "redux/actions/orders/ordersActions";

const style = {
  width: "100%",
  padding: "2px 8px",
  borderRadius: 4,
  marginLeft: 0,
  transition: "0.3s ease",
};
export const FilterSwitches = () => {
  const {
    temp: { ON_TIME, DELAYED, LATE, FINISHED },
    timing,
  } = useSelector(({ orders }) => orders);
  const { isDark } = useThemeMode();
  const dispatch = useDispatch();

  const handleFilters = (field) => {
    dispatch(filtersOrders(field));
  };

  return (
    <Grid container spacing={1} style={{ marginTop: 8 }}>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <OnTimeSwitch
              checked={timing.ON_TIME}
              onClick={() => handleFilters("on_time")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(green, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {ON_TIME.length}
              </span>
              - A tiempo
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(green, isDark),
            backgroundColor: getSwitchBg(green, timing.ON_TIME, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <DelayedSwitch
              checked={timing.DELAYED}
              onClick={() => handleFilters("delayed")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(orange, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {DELAYED.length} 
              </span>
              - Demorados
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(orange, isDark),
            backgroundColor: getSwitchBg(orange, timing.DELAYED, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <CancelledSwitch
              checked={timing.LATE}
              onClick={() => handleFilters("late")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(red, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {LATE.length} 
              </span>
              - Retrasados
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(red, isDark),
            backgroundColor: getSwitchBg(red, timing.LATE, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <DoneSwitch
              checked={timing.FINISHED}
              onClick={() => handleFilters("finished")}
            />
          }
         label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(blue, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {FINISHED.length} 
              </span>
              - Finalizados
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(blue, isDark),
            backgroundColor: getSwitchBg(blue, timing.FINISHED, isDark),
          }}
        />
      </Grid>
    </Grid>
  );
};
